/**
 * Contexto para comunicar transferências recebidas na blockchain
 * ao usuário que está cobrando (fecha QR e mostra popup com detalhes).
 */

import React, { createContext, useState, useCallback } from 'react';

export const IncomingTransferContext = createContext(null);

export function IncomingTransferProvider({ children }) {
  const [incomingTransfer, setIncomingTransfer] = useState(null);

  const reportIncomingTransfer = useCallback((data) => {
    if (data && typeof data === 'object') {
      setIncomingTransfer({
        amount: data.amount ?? 0,
        symbol: data.symbol ?? '',
        txHash: data.txHash ?? '',
        networkName: data.networkName ?? '',
        chainId: data.chainId ?? '',
        tokenAddress: data.tokenAddress ?? '',
        fromAddress: data.fromAddress ?? '',
        receivedAt: data.receivedAt ?? Date.now(),
      });
    }
  }, []);

  const clearIncomingTransfer = useCallback(() => {
    setIncomingTransfer(null);
  }, []);

  const value = {
    incomingTransfer,
    reportIncomingTransfer,
    clearIncomingTransfer,
  };

  return (
    <IncomingTransferContext.Provider value={value}>
      {children}
    </IncomingTransferContext.Provider>
  );
}
